import styles from "./LoadingSpinner.module.css";
import { useTranslation } from "react-i18next";

type LoadingSpinnerProps = {
  message?: string;
};

export default function LoadingSpinner({ message }: LoadingSpinnerProps) {
  const { t } = useTranslation();
  const resolvedMessage = message || t("common.status.loading");

  return (
    <div className={styles.shell} role="status" aria-live="polite" aria-label={resolvedMessage}>
      <div className={styles.inner}>
        <div className={styles.spinner} aria-hidden="true" />
        <p className={styles.message}>{resolvedMessage}</p>
      </div>
    </div>
  );
}
